import React from 'react'
import { IProps } from './index'

import { TabPill } from '../../elements/TabPill'
import { mq } from '../../utils'

export function TabPills({ tabPills }: IProps): React.ReactElement {
  return (
    <>
      <div className="tab-pills">
        <ul className="tab-pills__container">
          {tabPills.map((pill) => (
            <li key={pill.text} data-testid="tab-pill-item">
              <TabPill {...pill} />
            </li>
          ))}
        </ul>
      </div>
      <style jsx>{`
        .tab-pills {
          @media (${mq.largePhone}) {
            overflow-x: scroll;
            position: relative;
            margin: 0 auto;
            padding-bottom: 3.5rem;
          }

          &__container {
            display: flex;
            gap: 2rem;
            justify-content: center;
            align-items: center;

            @media (${mq.largePhone}) {
              justify-content: space-between;
              position: absolute;
              gap: 0.9375rem;
              margin: 0 auto;
              width: 100%;
            }

            @media (max-width: 375px) {
              position: absolute;
              width: auto;
            }
          }
        }
      `}</style>
    </>
  )
}
